<form-wrapper>
  @if (loading) {
    <pr-loader></pr-loader>
  }

  <ea-simulation-packs
    [packService]="'scpi'"
    [simulation]="simulation"
    (packSelected)="onPackSelected($event)"
    [withTable]="false"
    [withCustomPack]="false"
  >
  </ea-simulation-packs>
</form-wrapper>
<form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
